import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { accountSettingsDefaultBillingShippingStyles } from "@insite/content-library/Widgets/AccountSettings/AccountSettingsDefaultBillingShipping";
import getColor from "@insite/mobius/utilities/getColor";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

accountSettingsDefaultBillingShippingStyles.pickUpLocation = {
    gridContainer: { gap: 5 },
    headingGridItem: { width: 12 },
    headerText: {
        variant: "h5",
        css: css`
            margin-bottom: 0;
        `,
    },
    changeLink: {
        css: css`
            margin-left: 10px;
            /* Not needed */
            display: none;
            > span {
                &:hover {
                    text-decoration-line: underline;
                    color: ${getColor("text.link")};
                }
            }
        `,
    },
    warehouseGridItem: {
        width: 12,
    },
    warehouseAddress: {
        nameText: {
            as: "p",
        },
    },
};

accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle = mergeToNew(
    accountSettingsDefaultBillingShippingStyles.defaultBillingShippingTitle,
    {
        css: css`
            font-size: 20px;
            font-weight: ${TYPOGRAPHY.weight.bold};
        `,
    },
);
